import Swal from 'sweetalert2';
import MSCrequest from '../../../services/MSC/MSCrequest';
import logger from '../../../services/LocalServer/logger';

export default async function MscCart(cart, preview, loading) {
  return new Promise(async (resolve, reject) => {
    if (loading) {
      Swal.fire({
        allowOutsideClick: false,
        title: `Processing...`,
        didOpen: () => {
          Swal.showLoading();
        },
      });
    }

    const resID = localStorage.getItem('MSC_RES');
    const rvcid = localStorage.getItem('MSC_RVC');
    const workstationId = localStorage.getItem('MSC_WORKSTATION');
    const vendor = localStorage.getItem('MSC_VENDOR');
    const machineID = localStorage.getItem('machineID');

    console.log('rvcid', rvcid);
    console.log('workstationId', workstationId);
    console.log('vendor', vendor);
    console.log('resID', resID);
    let balance = 0;
    let total = 0;
    logger(2, 'Start Check Balance');
    await MSCrequest({
      method: 'get',
      url: `/finance/v1/posting-detail/get-floor-credit-limit?reservationId=${resID}`,
    })
      .then((res) => {
        balance = parseFloat(res.data.responsePayload?.remainingBalance);
        logger(
          2,
          'balance =' + JSON.stringify(parseFloat(res.data.responsePayload?.remainingBalance))
        );
        console.log('balance', parseFloat(res.data.responsePayload?.remainingBalance));
      })
      .catch((err) => {
        logger(1, 'Fail to Check Balance = ' + JSON.stringify(err));
        resolve(false);
      });
    logger(2, 'Start Price post/preview = ' + preview);
    await MSCrequest({
      method: 'post',
      url: `pos/v1/pos-operations/external-fast-transactions`,
      data: {
        addArticles: cart,
        addTenderMedia: {
          buyer: resID,
        },
        beginCheckDTO: {
          checksConsumerDTOs: [
            {
              reservation: resID,
            },
          ],
          rvcId: rvcid,
          workstationId: workstationId,
        },
        externalCodeType: vendor,
        externalUniqueId: machineID + new Date().getTime(),
        preview: preview,
      },
    })
      .then((res) => {
        logger(2, 'Successfully check Preview = ');
        console.log('pricePreview', res.data);
        console.log('subtotal', res.data?.responsePayload?.checkDTO?.subTotal);
        total = parseFloat(res.data?.responsePayload?.checkDTO?.subTotal);
        const detail = res.data?.responsePayload?.checkDTO?.checksDetails;
        const oldTotal = parseFloat(res.data?.responsePayload?.checkDTO?.grossTotal);
        for (let i = 0; i < cart?.length; i++) {
          cart[i].total = parseFloat(detail[i].total);
          cart[i].checkTotal = parseFloat(detail[i].checkTotal);
        }

        resolve({
          oldTotal: oldTotal,
          total: total,
          balance: balance,
          cart: cart,
          discount: parseFloat((oldTotal - total).toFixed(2)),
        });
      })
      .catch((err) => {
        logger(2, 'Fail to check Preview = ' + JSON.stringify(err));
        resolve(false);
      });
  });
}
